export const handlePrint = async (docId, fetchDeliveryCollectionPrint) => {
  try {
    const collectionRes = await fetchDeliveryCollectionPrint({ id: docId }).unwrap();

    const totalCharge =
      collectionRes?.data?.reduce(
        (total, row) =>
          total +
          (row?.shipmentPrices?.length
            ? row.shipmentPrices.reduce((sum, price) => sum + (price.charge || 0), 0)
            : row?.codAmount || 0),
        0
      ) || collectionRes?.collectionAmount || 0;

    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    document.body.appendChild(iframe);

    const doc = iframe.contentWindow.document;
    doc.open();
    doc.write(`
      <html>
        <head>
          <style>
            body { 
              font-family: 'Roboto', Arial, sans-serif; 
              padding: 30px; 
              font-size: 14px;
              line-height: 1.6;
              background-color: #f5f5f5;
            }
            .container {
              max-width: 900px;
              margin: 0 auto;
              background: white;
              padding: 25px;
              border-radius: 8px;
              box-shadow: 0 2px 8px rgba(0,0,0,0.1);
            }
            .header { 
              display: flex; 
              justify-content: space-between; 
              align-items: flex-start;
              flex-wrap: wrap; 
              margin-bottom: 30px;
              border-bottom: 1px solid #e0e0e0;
              padding-bottom: 20px;
            }
            .table { 
              width: 100%; 
              border-collapse: separate;
              border-spacing: 0;
              margin-top: 20px;
              background: white;
              border-radius: 6px;
              overflow: hidden;
            }
            .table th, .table td { 
              border: none;
              padding: 12px; 
              text-align: left;
              font-size: 13px;
            }
            .table th { 
              background-color: #1976d2;
              color: white;
              font-weight: 500;
              text-transform: uppercase;
            }
            .table td { 
              border-bottom: 1px solid #e0e0e0;
            }
            .table td.number { 
              text-align: right; 
            }
            .logo { 
              max-width: 140px; 
              max-height: 90px;
              border-radius: 4px;
            }
            .text-right { 
              text-align: right; 
            }
            .company-info h3 { 
              margin: 0 0 12px 0; 
              font-size: 20px;
              color: #1a1a1a;
            }
            .company-info p { 
              margin: 4px 0; 
              font-size: 13px;
              color: #4a4a4a;
            }
            .invoice-info h3 { 
              margin: 0 0 8px 0; 
              font-size: 18px;
              color: #1976d2;
            }
            .invoice-info p { 
              margin: 4px 0; 
              font-size: 13px;
              color: #4a4a4a;
            }
            .total-row { 
              font-weight: 600; 
              background-color: #f8f9fa;
              color: #1a1a1a;
            }
            .vendor-info {
              margin: 20px 0;
              padding: 15px;
              background-color: #f8f9fa;
              border-radius: 6px;
              border-left: 4px solid #1976d2;
            }
            .billing-customer {
              margin: 15px 0;
              font-size: 16px;
              font-weight: 500;
              color: #1a1a1a;
              background: #e3f2fd;
              padding: 10px 15px;
              border-radius: 4px;
            }
          </style>
        </head>
        <body>
          <div class="container">
            <div class="header">
              <div>
                ${collectionRes?.logoName ? `<img src="${collectionRes.logoName}" alt="Company Logo" class="logo" />` : ""}
              </div>
              <div style="flex: 1; margin-left: 25px;">
                <div style="display: flex; justify-content: space-between; align-items: flex-start;">
                  <div class="company-info">
                    <h3>${collectionRes?.entityName || "N/A"}</h3>
                    <p>${collectionRes?.entityLocation || "N/A"}</p>
                    <p>VAT Number: ${collectionRes?.entityVatNumber || "N/A"}</p>
                    <p>PAN Number: ${collectionRes?.entityPanNumber || "N/A"}</p>
                  </div>
                  <div class="invoice-info text-right">
                    <h3>Delivery Collection</h3>
                    <h3>#${collectionRes?.deliveryCollectionId || "N/A"}</h3>
                    <p>Date: ${new Date(collectionRes?.createdAt).toLocaleString("en-US", {
      timeZone: "Asia/Kathmandu",
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    })}</p>
    <p>Collection Method: ${collectionRes?.collectionMode || "N/A"}</p>
${collectionRes?.collectionMode === "Bank" && collectionRes?.bankName
        ? `<p>Bank Name: ${collectionRes.bankName}</p>`
        : ""
      }

                  </div>
                </div>
              </div>
            </div>

            <div class="billing-customer">
              Billing Customer: ${collectionRes?.data?.[0]?.customerUser ||
      collectionRes?.data?.[0]?.vendorShopName ||
      "N/A"}
            </div>

            <table class="table">
              <thead>
                <tr>
                  <th style="width: 8%;">SN</th>
                  <th style="width: 20%;">Shipment ID</th>
                  <th style="width: 25%;">Customer Name</th>
                  <th style="width: 15%;" class="text-right">Charge (Rs.)</th>
                </tr>
              </thead>
              <tbody>
                ${collectionRes?.data
        ?.map((row, index) => {
          const charge = row?.shipmentPrices?.length
            ? row.shipmentPrices.reduce((sum, price) => sum + (price.charge || 0), 0)
            : row?.codAmount || 0;

          return `
                      <tr>
                        <td>${index + 1}</td>
                        <td>${row?.shipmentId || "N/A"}</td>
                        <td>${row?.receiver?.customerUser || row?.vendorShopName || "N/A"}</td>
                        <td class="number">${charge.toFixed(2)}</td>
                      </tr>
                    `;
        })
        .join("") || ""
      }
                <tr class="total-row">
                  <td colspan="3" style="text-align: right; font-weight: 600;">
                    Total Collection Amount:
                  </td>
                  <td class="number" style="font-weight: 600;">
                    Rs. ${totalCharge.toFixed(2)}
                  </td>
                </tr>
                ${collectionRes?.actualAmount !== collectionRes?.collectionAmount
        ? `
                    <tr>
                      <td colspan="3" style="text-align: right;">
                        <strong>Expected Amount:</strong>
                      </td>
                      <td class="number">
                        <strong>Rs. ${collectionRes?.collectionAmount?.toFixed(2) || "0.00"}</strong>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="3" style="text-align: right;">
                        <strong>Actual Collected:</strong>
                      </td>
                      <td class="number">
                        <strong>Rs. ${collectionRes?.actualAmount?.toFixed(2) || "0.00"}</strong>
                      </td>
                    </tr>
                  `
        : ""
      }
              </tbody>
            </table>
          </div>
        </body>
      </html>
    `);
    doc.close();

    setTimeout(() => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
    }, 500);

    setTimeout(() => {
      if (document.body.contains(iframe)) {
        document.body.removeChild(iframe);
      }
    }, 2000);
  } catch (error) {
    console.error("Failed to fetch Delivery Collection data for printing:", error);
    alert("Failed to load print data. Please try again.");
  }
};